module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/146FeuL/tc-custom/9781637151815.jpg?1695676356320",
      "alt": "This image is the cover for the book Rick and Morty: vs. Cthulhu  #4, Rick and Morty"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rick and Morty: vs. Cthulhu  #4, Rick and Morty\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It's R'yleh happening! In the final confrontation of the Smith-Sanchez Lovecraftian horror saga, family turns on family, and the battle for pop culture relevance is waged between Rick and Cthulhu—with devastating stakes.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jim Zub, Troy Little, Leonardo Ito, Crank!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jim Zub is a writer, artist and art instructor based in Toronto, Canada. Over the past twenty years he’s worked for a diverse array of publishing, movie and video game clients including Marvel, DC Comics, Disney, Capcom, Hasbro, Cartoon Network, and Bandai-Namco. He juggles his time between being a freelance comic writer and a professor teaching drawing and storytelling courses in Seneca College’s award-winning Animation program. His current comic projects include Conan the Barbarian, the monthly adventures of Robert E. Howard’s legendary sword& sorcery hero, Dungeons & Dragons, the official comic series of the world’s most popular tabletop role-playing game, and Stone Star, a space-fantasy adventure set inside a roving gladiatorial arena.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0